import { useContext } from 'react';
import classNames from 'classnames';
import { getSmallClassList } from '@medifind/utils';
import { CardContext } from './Card';
import styles from './CardActionButtonWrapper.module.scss';

const CardActionButtonWrapper = ({ children, useOffset = true, classes = {} }) => {
  const { smallAt } = useContext(CardContext);
  const { smallClassList } = getSmallClassList(smallAt, styles);
  return (
    <div
      className={classNames(
        styles['card-action-button-wrapper'],
        smallClassList,
        {
          [styles['offset']]: useOffset,
        },
        classes.actionButtonWrapper,
      )}
    >
      {children}
    </div>
  );
};

export { CardActionButtonWrapper as default, CardActionButtonWrapper };
